import React from 'react';
import View from './view';
import {useSelector} from 'react-redux';
import {contentSelector} from '../../redux/selectors/resources';

export const SocialSupportMeasuresScreen = () => {
  const content = useSelector(contentSelector());

  return <View content={content} />;
};
